import { render, staticRenderFns } from "./MyCandidates.vue?vue&type=template&id=a30c4c74&scoped=true&"
import script from "./MyCandidates.vue?vue&type=script&lang=js&"
export * from "./MyCandidates.vue?vue&type=script&lang=js&"
import style0 from "./MyCandidates.vue?vue&type=style&index=0&id=a30c4c74&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a30c4c74",
  null
  
)

export default component.exports